import { render, staticRenderFns } from "./PopUpUser.vue?vue&type=template&id=63956b44&scoped=true&"
import script from "./PopUpUser.vue?vue&type=script&lang=js&"
export * from "./PopUpUser.vue?vue&type=script&lang=js&"
import style0 from "./PopUpUser.vue?vue&type=style&index=0&id=63956b44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63956b44",
  null
  
)

export default component.exports